export class ReliabilityPrematureFailureUpdateModel {
  public Id?: number;
  public RequestOrderId?: number;
  public RequestType?: number;
  public ReportId?: number;
  public BeforeRemovalOrderType?: string;
  public BeforeRemovalOrderNumber?: number;
  public BeforeRemovalOrderStatus?: string;
  public BeforeRemovalVendorType?: string;
  public BeforeRemovalVendor?: string;
  public BeforeRemovalCondition?: string;
  public AfterRemovalOrderType?: string;
  public AfterRemovalOrderNumber?: number;
  public AfterRemovalOrderStatus?: string;
  public AfterRemovalVendorType?: string;
  public AfterRemovalVendor?: string;
  public AfterRemovalCondition?: string;
  public PrematureFailureStatus?: number;
  public Reason?: number;
  public OtherReason?: string;
}
